// src/components/PieCategoryChart.tsx
import { useEffect, useRef } from "react";
import { Pie } from "@antv/g2plot";

export function PieCategoryChart({ receipts = [] }) {
  const containerRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const map = {};

    for (const r of receipts) {
      const cat = r.category?.trim() || "Outros";
      const value = Number(r.totalValue);

      if (!isNaN(value)) {
        map[cat] = (map[cat] || 0) + value;
      }
    }

    const data = Object.entries(map).map(([label, value]) => ({
      label,
      value,
    }));

    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }

    chartRef.current = new Pie(containerRef.current, {
      data,
      autoFit: true,
      angleField: "value",
      colorField: "label",
      radius: 0.9,
      innerRadius: 0.65,
      legend: false,

      statistic: {
        title: {
          content: "Total",
          style: {
            color: "var(--text-primary)",
            fontSize: 12,
          },
        },
        content: {
          customHtml: () => {
            const total = data.reduce((acc, d) => acc + d.value, 0);

            const formatted =
              total >= 1_000_000
                ? `R$ ${(total / 1_000_000).toFixed(1)}M`
                : total >= 1_000
                  ? `R$ ${(total / 1_000).toFixed(1)}K`
                  : total.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                    maximumFractionDigits: 2,
                  });

            return `
              <div style="
                width: 100%;
                text-align: center;
                line-height: 1.2;
                font-weight: 600;
                color: var(--text-primary);
                font-size: clamp(14px, 4vw, 22px);
              ">
                ${formatted}
              </div>
            `;
          },
        },
      },

      label: false,

      tooltip: {
        formatter: (item) => ({
          name: item.label,
          value: item.value.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
        }),
      },
    });

    chartRef.current.render();
    return () => {
      chartRef.current?.destroy();
      chartRef.current = null;
    };
  }, [receipts]);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: 260,
      }}
    />
  );
}
